"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ChatPanelModule {
}
exports.ChatPanelModule = ChatPanelModule;
